import SimpleSelect from '@components/V3/forms/SimpleSelect'
import {} from 'simple-react-form'
import {ReservationLabel} from './Label'
import {useCreateReservationContext} from './ReservationContext'

export default function ReservationsCheckoutTable() {
  const {tableIds, setTableIds, storeOptions, availabilityOptions, sectorId} =
    useCreateReservationContext()

  if (!storeOptions.allowSelectTable) return null
  if (!availabilityOptions.selectedOption?.availableTableOptions?.length) return null

  return (
    <div className="">
      <ReservationLabel className="mb-3">¿Quieres elegir una mesa? (opcional)</ReservationLabel>
      <SimpleSelect
        fieldName="tableId"
        value={tableIds?.join(',') || ''}
        options={[
          {
            label: 'Selección automática de mesa',
            value: '',
          },
          ...(availabilityOptions.selectedOption?.availableTableOptions
            ?.filter(option => option.sectorId === sectorId)
            ?.map(option => ({
              label: option.label,
              value: option.tableIds.join(','),
            })) || []),
        ]}
        onChange={value => {
          const val = value as string
          setTableIds(val ? val.split(',') : [])
        }}
        placeholder="Selecciona una mesa"
      />
    </div>
  )
}
